export const editOrCreateFileToolMessage = (toolMessage: any, results: any, toolName: string) => {
    const operation = toolName === "editFile" ? "edited" : "created";

    if (results.errorMessage) {
        const content = [{type: 'text', text: results.errorMessage}];

        const truncatedMessage = operation === "created" ? "File already exists." : results.errorMessage;
        const truncatedContent = [{type: 'text', text: truncatedMessage}];

        return  {...toolMessage, content: content, truncatedContent: truncatedContent};
    }

    let contextText = `File successfully ${operation}! Here's the updated state of the file. Take a look and make sure it looks as expected before responding again:\n\`\`\`${results.languageName}\n${results.newFileContents}\n\`\`\`\n\nIf you are encountering persistent errors, searching the internet may help.`;
    let truncatedContextText = `File successfully ${operation}! Here's the updated state of the file:\n\`\`\`${results.languageName}\n<Truncated for brevity>\n\`\`\``;
    if (results.fileErrors.trim() !== '') {
        contextText += `\n\nHere are the errors in the file:\n\`\`\`\n${results.fileErrors}\n\`\`\``;
    }

    const content = [{
        type: 'text',
        text: contextText
    }];
    const truncatedContent = [{
        type: 'text',
        text: truncatedContextText
    }];

    return {...toolMessage, content: content, truncatedContent: truncatedContent};
}
